import { useCallback } from 'react'
import ApiService from 'services/ApiService'

const InteractorMasterCitySearch = () => {
  const citySearch = useCallback((body, callback, loading) => {
    const payload = {
      ...body,
    }
    ApiService.jsonRequest('/management/master-city/search', payload, (response) => {
      loading(false)
      if (response.code === 7200) {
        callback(response.data)
      } else {
        callback(null)
      }
    })
  }, [])

  return { citySearch }
}

export default InteractorMasterCitySearch
